import { faBuildingColumns, faLink } from '@awesome.me/kit-4a6bf60416/icons/classic/solid';

import { Icon } from '@/components/ui/icon';
import type { PaymentMethod } from '@/pages/cms/billing/types';
import { getCardBrandIcon } from './card-brand-icons';

export function getPaymentMethodIcon(paymentMethod: PaymentMethod) {
  switch (paymentMethod.type) {
    case 'card':
      return getCardBrandIcon(paymentMethod.brand);
    case 'us_bank_account':
      return {
        node: <Icon icon={faBuildingColumns} size="lg" className="text-primary" />,
        label: 'Bank account',
      };
    case 'link':
      return {
        node: <Icon icon={faLink} size="lg" className="text-green-600" />,
        label: 'Link',
      };
  }
}

// Card logos already read as icons; bank/Link glyphs get a bordered box so they don't look broken.
export function PaymentMethodIcon({ paymentMethod }: { paymentMethod: PaymentMethod }) {
  const { node } = getPaymentMethodIcon(paymentMethod);

  if (paymentMethod.type === 'card') return node;

  return (
    <div className="flex h-8 w-[46px] shrink-0 items-center justify-center rounded-sm border border-border bg-background">
      {node}
    </div>
  );
}

export function paymentMethodLabel(paymentMethod: PaymentMethod, brandLabel: string): string {
  switch (paymentMethod.type) {
    case 'card':
      return `${brandLabel} •••• ${paymentMethod.last4}`;
    case 'us_bank_account':
      return `${paymentMethod.bankName} •••• ${paymentMethod.last4}`;
    case 'link':
      return 'Link';
  }
}

export function paymentMethodSecondaryText(paymentMethod: PaymentMethod): string | null {
  if (paymentMethod.type === 'card') {
    const expirationYear = paymentMethod.expYear.toString().slice(-2);
    return `Expires ${paymentMethod.expMonth.toString().padStart(2, '0')}/${expirationYear}`;
  }
  if (paymentMethod.type === 'link') {
    return paymentMethod.email;
  }
  return null;
}
